module.exports = __webpack_public_path__ + "static/media/28DGC5.6bc2a831.jpg";